import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import LegacyTextRenderer from '../../../TextRenderer/LegacyTextRenderer';
import { pushConfirmationModal } from '../../../Modals/redux/actionCreators';
import { extConfigFullscreen } from '@wix/da-editor-tiptap/pkg/components/Editor/presets/DeviationDescription/config';
import s from './LegacyDescriptionEditor.scss';
const LegacyDescriptionEditor = ({ descriptionHtml, onConvertToDraft })=>{
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const handleClick = useCallback(()=>dispatch(pushConfirmationModal({
            title: t('deviationSubmit.form.description.convertConfirmModal.title'),
            text: t('deviationSubmit.form.description.convertConfirmModal.message'),
            confirmBtnLabel: t('deviationSubmit.form.description.convertConfirmModal.confirm'),
            confirmBtnType: 'danger',
            onConfirm: async ()=>{
                const mod = await import(/* webpackChunkName: "editor_v3", webpackPrefetch: true */ '@wix/da-editor-tiptap/pkg/converters/fromWriterHtml');
                var _descriptionHtml_markup;
                onConvertToDraft(mod.fromWriterHtml((_descriptionHtml_markup = descriptionHtml.markup) !== null && _descriptionHtml_markup !== void 0 ? _descriptionHtml_markup : '', extConfigFullscreen));
            }
        })), [
        dispatch,
        t,
        onConvertToDraft,
        descriptionHtml.markup
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        onClick: handleClick
    }, /*#__PURE__*/ React.createElement(LegacyTextRenderer, {
        html: descriptionHtml.markup
    }));
};
LegacyDescriptionEditor.displayName = 'LegacyDescriptionEditor';
export default LegacyDescriptionEditor;

//# sourceMappingURL=LegacyDescriptionEditor.js.map